import React from 'react';
import style from './Picture.module.css';

/**
 * ## Display an picture of me for huge screens
 *
 * ℹ️ The image is specified in the css file.
 *
 * @returns React.ReactNode
 */
function BigPicture() {
  return (
    <div
      id={style.picture}
      data-testid="bigPicture"
      className="col-lg-3 bg position-fixed d-none d-lg-block"
    />
  );
}

export default BigPicture;
